<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import type { HTMLTextareaAttributes } from "svelte/elements";
	import { updateTextareaHeight } from "@core/utils/updateTextareaHeight.js";

	const { ...rest }: HTMLTextareaAttributes = $props();

	let validityMessage = $state("");
	function validate({ currentTarget }: Event & { currentTarget: EventTarget & HTMLTextAreaElement }): void {
		if (currentTarget.validity.valid) {
			currentTarget.setCustomValidity("");
		}
		validityMessage = currentTarget.validationMessage;
	}
</script>

<textarea
	use:updateTextareaHeight
	{...rest}
	class={[
		"border border-fcrlightgray-300 rounded-3xl bg-fcrlightgray-200 p-6 resize-none",
		"text-base text-fcrdarkgray placeholder:text-fcrgray w-full !outline-none",
		"focus:border-fcrdarkgray focus:border-2",
		"[&:user-invalid]:border-fcrerror [&:user-invalid]:border-2",
		rest.class,
	]}
	oninvalid={(event: Event & { currentTarget: EventTarget & HTMLTextAreaElement }): void => {
		event.preventDefault();
		validate(event);
	}}
></textarea>
{#if validityMessage.length > 0}
	<div class="flex justify-end text-sm text-fcrerror pr-6 pt-1">
		<Formatted text={validityMessage} />
	</div>
{/if}
